import React, { Fragment, h } from "preact";
import './Table.scss';

export default function TableContainer ({children, className}) {
    const classNameStyle = className ? className : 'default';

    return (
        <div className={`component-table ${classNameStyle}`}>
            {children}
        </div>
    )
}